import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const marketplaceBadgeVariants = cva(
  "inline-flex shrink-0 items-center justify-center rounded-[4px] bg-subtle px-1 text-micro font-medium tracking-caps",
  {
    variants: {
      size: {
        // Inside 32px controls and menu rows (shop scope trigger and tree).
        md: "h-[18px] min-w-[22px] text-ink",
        // Metadata under a name in tables and cards.
        sm: "h-4 text-text-secondary",
      },
    },
    defaultVariants: { size: "md" },
  },
);

export function MarketplaceBadge({
  code,
  size,
  className,
}: { code: string; className?: string } & VariantProps<typeof marketplaceBadgeVariants>) {
  return <span className={cn(marketplaceBadgeVariants({ size }), className)}>{code}</span>;
}
